import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import '@/assets/css/css.css'

createApp(App).use(router).mount(document.getElementById('app'))
